import { Avatar, Checkbox, Form } from 'antd';
import { useMemo } from 'react';
import shopSelectors from 'services/selectors/shop';
import styled from 'styled-components';
import qbSignal from '../signal';
import ModalStaff, { useModalStaffRef } from '../ModalStaff';
import { IStaffUI } from 'types/staff';
import { ANYONE } from 'Calendar/anyone';
import iconRemove from '../icon-remove.svg';
import { isBookableStaff } from 'utils/staff';


type StaffSectionProps = {
  staff: IStaffUI | null;
  remove: () => void;
  disabledRemove?: boolean;
  name?: any;
  onChangeStaff?: () => void;
};
const StaffSection = ({ staff, remove, disabledRemove, name, onChangeStaff }: StaffSectionProps) => {
  const staffModalRef = useModalStaffRef();
  const _staffStoreAll = shopSelectors.staff();
  // Memoised so the filtered array keeps a stable identity across renders.
  const _staffStore = useMemo(() => _staffStoreAll.filter(isBookableStaff), [_staffStoreAll]);
  const staffStore = useMemo(() => [ANYONE].concat(_staffStore), [_staffStore]);
  const staffSelected = useMemo(() => {
    return staffStore.filter(o => (qbSignal.staffs.value.includes(o.id)));
  }, [staffStore, qbSignal.staffs.value]);

  const handleChooseStaff = (staff: IStaffUI, extraData?: IStaffUI) => {
    const temp = [...qbSignal.staffs.value];
    // Add new
    if (!extraData) {
      if (qbSignal.staffs.value?.includes(staff.id)) return;
      temp.push(staff.id);
      qbSignal.staffs.value = temp;
      return;
    }
    // update

    const existIdx = qbSignal.staffs.value.indexOf(extraData.id);
    if (existIdx === -1) return;
    temp[existIdx] = staff.id;
    qbSignal.staffs.value = temp;
  };

  return (
    <Container>
      <div className="staff-ui">
        <Avatar size={'small'} src={staff?.avatar} style={{ backgroundColor: '#148CF1' }}>{staff?.name?.[0] || 'A'}</Avatar>
        <span className="staff-name">{staff?.name}</span>
        <button onClick={() => onChangeStaff?.()} type='button' className='btn-change'>{iconChange}</button>
      </div>
      <Form.Item name={[name, 'requestStaff']} noStyle valuePropName='checked'>
        <Checkbox
          className='value-section checkbox-request-staff'
        >
          Request Staff
        </Checkbox>
      </Form.Item>
      {!disabledRemove && <button onClick={remove} type='button' className='btn-remove' disabled={disabledRemove}>
        <img src={iconRemove} alt="iconRemove" />
      </button>}
    </Container>
  );
};

export default StaffSection;


const Container = styled.div`
  display: flex;
  align-items: center;

  .staff-ui {
    flex: 1;
    display: flex;
    align-items: center;
    .ant-avatar.ant-avatar-sm {
      zoom: 2;
    }

    .staff-name {
      margin-left: 8px;
      color: #1D2129;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .btn-change {
      width: 46px;
      height: 46px;
    }
  }

  .btn-remove {
    width: 46px;
    height: 46px;
  }
`;

const iconChange = <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M8.9309 8.92701C10.4222 7.43572 12.2637 6.51544 14.1899 6.16257L13.7094 3.53955C11.2679 3.98682 8.93137 5.15531 7.04528 7.0414C2.09864 11.988 2.09864 20.0081 7.04528 24.9548L4.76913 27.2309H11.207V20.793L8.93089 23.0692C5.02565 19.1639 5.02565 12.8323 8.9309 8.92701ZM27.2324 4.76762H20.7945V11.2055L23.0707 8.92938C26.9759 12.8346 26.9759 19.1663 23.0707 23.0715C21.5794 24.5628 19.7379 25.4831 17.8116 25.836L18.2922 28.459C20.7336 28.0117 23.0702 26.8432 24.9563 24.9571C29.9029 20.0105 29.9029 11.9904 24.9563 7.04376L27.2324 4.76762Z" fill="#148CF1" />
</svg>;
